import { ENTITY_STATUS } from "../../config/constants";
import { LOGOUT_SUCCESS } from "../types/authTypes";
import {
  BILL_UPLOAD_ERROR,
  BILL_UPLOAD_LOADING,
  BILL_UPLOAD_SUCCESS,
  DELETE_INVOICE_ERROR,
  DELETE_INVOICE_SUCCESS,
  DOWNLOAD_INVOICE_FILE,
  DOWNLOAD_INVOICE_FILE_LOADING,
  DOWNLOAD_INVOICE_SUCCESS,
  FETCH_DOC_ITEMS_ERROR,
  FETCH_DOC_ITEMS_SUCCESS,
  FETCH_DOC_JOB_ERROR,
  FETCH_DOC_JOB_LOADING,
  FETCH_DOC_JOB_SUCCESS,
  FETCH_DOC_USERS_ERROR,
  FETCH_DOC_USERS_SUCCESS,
  FETCH_ERROR_INVOICES_ERROR,
  FETCH_ERROR_INVOICES_SUCCESS,
  FETCH_INVOICES_ERROR,
  FETCH_INVOICES_SUCCESS,
  FETCH_JOB_ERROR,
  FETCH_JOB_LOADING,
  FETCH_JOB_STAT_ERROR,
  FETCH_JOB_STAT_LOADING,
  FETCH_JOB_STAT_SUCCESS,
  FETCH_JOB_SUCCESS,
  FETCH_USAGE_ERROR,
  FETCH_USAGE_LOADING,
  FETCH_USAGE_SUCCESS,
  GET_DOC_ERROR,
  GET_DOC_LOADING,
  GET_DOC_SUCCESS,
  GROUP_DATA_ERROR,
  GROUP_DATA_SUCCESS,
  SET_BILL_REDUCER,
  SUBMIT_BILL_ERROR,
  SUBMIT_BILL_LOADING,
  SUBMIT_BILL_SUCCESS,
  TEST_RESULT_ERROR,
  TEST_RESULT_LOADING,
  TEST_RESULT_SUCCESS,
  UPDATE_DOC_ERROR,
  UPDATE_DOC_LOADING,
  UPDATE_DOC_STATUS_ERROR,
  UPDATE_DOC_STATUS_LOADING,
  UPDATE_DOC_STATUS_SUCCESS,
  UPDATE_DOC_SUCCESS,
  GET_VALIDATIONS_LOADING,
  GET_VALIDATIONS_SUCCESS,
  GET_VALIDATIONS_ERROR,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_ERROR,
  MSME_DATA_ERROR,
  MSME_DATA_SUCCESS,
  MSME_DATA_LOADING,
  MSME_GET_CONV_ERROR,
  MSME_GET_CONV_SUCCESS,
  MSME_GET_CONV_LOADING,
  MSME_ADD_CONV_LOADING,
  MSME_ADD_CONV_SUCCESS,
  MSME_ADD_CONV_ERROR,
  MANUFACTURING_DATA_LOADING,
  MANUFACTURING_DATA_SUCCESS,
  MANUFACTURING_DATA_ERROR,
  DELETE_GROUPS_SUCCESS,
  DELETE_GROUPS_ERROR,
  HOF_DASHBOARD_SUCCESS,
  HOF_DASHBOARD_ERROR,
  MARUTI_DASHBOARD_LOADING,
  MARUTI_DASHBOARD_SUCCESS,
  MARUTI_DASHBOARD_ERROR,
} from "../types/billTypes";

const initState = {
  billUploadLoading: false,
  billUploadSuccess: false,
  billUploadError: false,
  billUploadMessage: null,
  billUploadData: null,

  submitBillLoading: false,
  submitBillSuccess: false,
  submitBillError: false,
  submitBillMessage: null,

  fethJobLoading: false,
  fethJobSuccess: false,
  fethJobError: false,
  jobs: null,
  fetchJobMessage: null,

  fetchJobBillsLoading: false,
  fetchJobBillsSuccess: false,
  fetchJobBillsError: false,
  jobBillsData: null,
  fetchJobBillsMsg: null,

  deleteInvoiceError: false,
  deleteInvoiceSuccess: false,
  deleteInvoiceMsg: null,

  testData: null,

  invoiceFileUrl: null,
  downloadInvoiceSuccess: false,

  errorInvoices: [],
  errorInvoicesMsg: "",

  docLoading: false,
  docSuccess: false,
  docError: false,
  document: null,

  docUpdateLoading: false,
  docUpdateSuccess: false,
  docUpdateError: false,
  newDocHisId: null,

  userDocsSuccess: false,
  userDocsError: false,
  userDocs: [],

  groupDocsSuccess: false,
  groupDocsError: false,

  invoiceItemsSuccess: false,
  invoiceItemsError: false,
  invoiceItems: [],

  usageLoading: false,
  usageSuccess: true,
  usageError: false,
  usage: [],

  validationsLoading: false,
  validationsSuccess: true,
  validationsError: false,
  validations: [],

  createProjectLoading: false,
  createProjectSuccess: true,
  createProjectError: false,
  newProjectId: null,

  msmeDashboardLoading: false,
  msmeDashboardSuccess: false,
  msmeDashboardError: false,
  msmeDashboardData: null,

  msmeAddConvLoading: false,
  msmeAddConvSuccess: false,
  msmeAddConvError: false,

  msmeGetConvLoading: false,
  msmeGetConvSuccess: false,
  msmeGetConvError: false,
  msmeConversations: null,

  manufacturingDashboardLoading: false,
  manufacturingDashboardSuccess: false,
  manufacturingDashboardError: false,
  manufacturingDashboardData: null,
  deleteGroupSuccess: false,
  deleteGroupError: false,

  hofDashboardSuccess: false,
  hofDashboardError: false,
  hofDashboardData: null,

  marutiDashboardLoading: false,
  marutiDashboardSuccess: false,
  marutiDashboardError: false,
  marutiDashboardData: null,
};

const billReducer = (state = initState, action) => {
  console.log("BILL DATA", action);

  switch (action.type) {
    case BILL_UPLOAD_LOADING:
      return {
        ...state,
        billUploadLoading: true,
        billUploadSuccess: false,
        billUploadError: false,
        billUploadMessage: null,
        billUploadData: null,
      };
    case BILL_UPLOAD_SUCCESS:
      return {
        ...state,
        billUploadLoading: false,
        billUploadSuccess: true,
        billUploadError: false,
        billUploadMessage: action.message,
        billUploadData: action.payload,
      };
    case BILL_UPLOAD_ERROR:
      return {
        ...state,
        billUploadLoading: false,
        billUploadSuccess: false,
        billUploadError: true,
        billUploadMessage: action.message,
        billUploadData: null,
      };
    case SUBMIT_BILL_LOADING:
      return {
        ...state,
        submitBillLoading: true,
        submitBillSuccess: false,
        submitBillError: false,
        submitBillMessage: null,
      };
    case SUBMIT_BILL_SUCCESS:
      return {
        ...state,
        submitBillLoading: false,
        submitBillSuccess: true,
        submitBillError: false,
        submitBillMessage: action.message || "Bill submited successfully.",
      };
    case SUBMIT_BILL_ERROR:
      return {
        ...state,
        submitBillLoading: false,
        submitBillSuccess: false,
        submitBillError: true,
        submitBillMessage: action.message || "Error to submit bill.",
      };
    case FETCH_JOB_LOADING:
      return {
        ...state,
        fethJobLoading: true,
        fethJobSuccess: false,
        fethJobError: false,
        jobs: null,
        fetchJobMessage: null,
      };
    case FETCH_JOB_SUCCESS:
      return {
        ...state,
        fethJobLoading: false,
        fethJobSuccess: true,
        fethJobError: false,
        jobs: action.payload,
        fetchJobMessage: action.message || "Job fetched successfully.",
      };
    case FETCH_JOB_ERROR:
      return {
        ...state,
        fethJobLoading: false,
        fethJobSuccess: false,
        fethJobError: true,
        jobs: null,
        fetchJobMessage: action.message || "Error to fetch job.",
      };
    case FETCH_INVOICES_SUCCESS:
      let data =
        action.payload?.rows?.filter(
          (bill) => bill._status !== ENTITY_STATUS.deleted,
        ) || [];
      return {
        ...state,
        fetchJobBillsLoading: false,
        fetchJobBillsSuccess: true,
        fetchJobBillsError: false,
        jobBillsData: data,
        fetchJobBillsMsg: action.message,
      };
    case FETCH_INVOICES_ERROR:
      return {
        ...state,
        fetchJobBillsLoading: false,
        fetchJobBillsSuccess: false,
        fetchJobBillsError: true,
        jobBillsData: null,
        fetchJobBillsMsg: action.message,
      };
    case FETCH_ERROR_INVOICES_SUCCESS:
      return {
        ...state,
        fetchJobBillsLoading: false,
        fetchJobBillsSuccess: true,
        fetchJobBillsError: false,
        errorInvoices:
          action.payload?.rows?.filter(
            (bill) => bill._status !== ENTITY_STATUS.deleted,
          ) || [],
        errorInvoicesMsg: action.message,
      };
    case FETCH_ERROR_INVOICES_ERROR:
      return {
        ...state,
        fetchJobBillsLoading: false,
        fetchJobBillsSuccess: false,
        fetchJobBillsError: true,
        errorInvoices: null,
        errorInvoicesMsg: action.message,
      };

    case TEST_RESULT_LOADING:
      return {
        ...state,
        testResult: null,
      };
    case TEST_RESULT_SUCCESS:
      return {
        ...state,
        testResult: action.payload,
      };
    case TEST_RESULT_ERROR:
      return {
        ...state,
        testResult: null,
      };

    case GET_DOC_LOADING:
      return {
        ...state,
        docLoading: true,
        docSuccess: false,
        docError: false,
        document: null,
      };
    case GET_DOC_SUCCESS:
      return {
        ...state,
        docLoading: false,
        docSuccess: true,
        docError: false,
        document: action.payload,
      };
    case GET_DOC_ERROR:
      return {
        ...state,
        docLoading: false,
        docSuccess: false,
        docError: false,
        document: null,
      };

    case DELETE_INVOICE_SUCCESS:
      return {
        ...state,
        deleteInvoiceSuccess: true,
        deleteInvoiceMsg: action.message,
      };
    case DELETE_INVOICE_ERROR:
      return {
        ...state,
        deleteInvoiceError: true,
        deleteInvoiceMsg: action.message,
      };
    case SET_BILL_REDUCER:
      return {
        ...state,
        ...action.payload,
      };
    case DOWNLOAD_INVOICE_FILE_LOADING:
      return {
        ...state,
        invoiceFileUrl: null,
      };
    case DOWNLOAD_INVOICE_FILE:
      return {
        ...state,
        invoiceFileUrl: action.payload,
      };
    case DOWNLOAD_INVOICE_SUCCESS:
      return {
        ...state,
        downloadInvoiceSuccess: true,
      };

    case UPDATE_DOC_LOADING:
      return {
        ...state,
        docUpdateLoading: true,
        docUpdateSuccess: false,
        docUpdateError: false,
        newDocHisId: null,
      };
    case UPDATE_DOC_SUCCESS:
      return {
        ...state,
        docUpdateLoading: false,
        docUpdateSuccess: true,
        docUpdateError: false,
        newDocHisId: action.payload,
      };
    case UPDATE_DOC_ERROR:
      return {
        ...state,
        docUpdateLoading: false,
        docUpdateSuccess: false,
        docUpdateError: true,
        newDocHisId: null,
      };
    case FETCH_DOC_USERS_SUCCESS:
      return {
        ...state,
        userDocsSuccess: true,
        userDocsError: false,
        userDocs: action.payload?.rows,
      };
    case FETCH_DOC_USERS_ERROR:
      return {
        ...state,
        userDocsSuccess: false,
        userDocsError: true,
        userDocs: [],
      };
    case FETCH_DOC_ITEMS_SUCCESS:
      return {
        ...state,
        invoiceItemsSuccess: true,
        invoiceItemsError: false,
        invoiceItems: action.payload?.rows,
      };
    case FETCH_DOC_ITEMS_ERROR:
      return {
        ...state,
        invoiceItemsSuccess: false,
        invoiceItemsError: true,
        invoiceItems: [],
      };
    case GROUP_DATA_SUCCESS:
      return {
        ...state,
        groupDocsSuccess: true,
        groupDocsError: false,
      };
    case GROUP_DATA_ERROR:
      return {
        ...state,
        groupDocsSuccess: false,
        groupDocsError: true,
      };

    case UPDATE_DOC_STATUS_LOADING:
      return {
        ...state,
        docUpdateLoading: true,
        docUpdateSuccess: false,
        docUpdateError: false,
      };
    case UPDATE_DOC_STATUS_SUCCESS:
      return {
        ...state,
        docUpdateLoading: false,
        docUpdateSuccess: true,
        docUpdateError: false,
      };
    case UPDATE_DOC_STATUS_ERROR:
      return {
        ...state,
        docUpdateLoading: false,
        docUpdateSuccess: false,
        docUpdateError: true,
      };
    case FETCH_USAGE_LOADING:
      return {
        ...state,
        usageLoading: true,
        usageSuccess: false,
        usageError: false,
      };
    case FETCH_USAGE_SUCCESS:
      return {
        ...state,
        usageLoading: false,
        usageSuccess: true,
        usageError: false,
        usage: action.payload,
      };
    case FETCH_USAGE_ERROR:
      return {
        ...state,
        usageLoading: false,
        usageSuccess: false,
        usageError: true,
      };
    case FETCH_DOC_JOB_LOADING:
      return {
        ...state,
        fetchDocJobLoading: true,
        fetchDocJobSuccess: false,
        fetchDocJobError: false,
        fetchDocJobMessage: null,
        docJobs: null,
      };
    case FETCH_DOC_JOB_SUCCESS:
      return {
        ...state,
        fetchDocJobLoading: false,
        fetchDocJobSuccess: true,
        fetchDocJobError: false,
        fetchDocJobMessage: action.message || "Job fetched successfully.",
        docJobs: action.payload,
      };
    case FETCH_DOC_JOB_ERROR:
      return {
        ...state,
        fetchDocJobLoading: false,
        fetchDocJobSuccess: false,
        fetchDocJobError: true,
        fetchDocJobMessage: action.message || "Error to fetch job.",
        docJobs: null,
      };
    case FETCH_JOB_STAT_LOADING:
      return {
        ...state,
        fetchJobStatLoading: true,
        fetchJobStatSuccess: false,
        fetchJobStatError: false,
        fetchJobStatMessage: null,
        jobStat: null,
      };
    case FETCH_JOB_STAT_SUCCESS:
      return {
        ...state,
        fetchJobStatLoading: false,
        fetchJobStatSuccess: true,
        fetchJobStatError: false,
        fetchJobStatMessage: action.message || "Job fetched successfully.",
        jobStat: action.payload,
      };
    case FETCH_JOB_STAT_ERROR:
      return {
        ...state,
        fetchJobStatLoading: false,
        fetchJobStatSuccess: false,
        fetchJobStatError: true,
        fetchJobStatMessage: action.message || "Error to fetch job.",
        jobStat: null,
      };
    case GET_VALIDATIONS_SUCCESS:
      return {
        ...state,
        validationsLoading: false,
        validationsSuccess: true,
        validationsError: false,
        validations: action.payload,
      };
    case GET_VALIDATIONS_ERROR:
      return {
        ...state,
        validationsLoading: false,
        validationsSuccess: false,
        validationsError: true,
        validations: [],
      };
    case CREATE_PROJECT_SUCCESS:
      return {
        ...state,
        createProjectLoading: false,
        createProjectSuccess: true,
        createProjectError: false,
        newProjectId: action.payload,
      };
    case CREATE_PROJECT_ERROR:
      return {
        ...state,
        createProjectLoading: false,
        createProjectSuccess: false,
        createProjectError: true,
        newProjectId: null,
      };
    case MSME_DATA_LOADING:
      return {
        ...state,
        msmeDashboardLoading: true,
        msmeDashboardSuccess: false,
        msmeDashboardError: false,
        msmeDashboardData: null,
      };
    case MSME_DATA_SUCCESS:
      return {
        ...state,
        msmeDashboardLoading: false,
        msmeDashboardSuccess: true,
        msmeDashboardError: false,
        msmeDashboardData: action.payload,
      };
    case MSME_DATA_ERROR:
      return {
        ...state,
        msmeDashboardLoading: false,
        msmeDashboardSuccess: false,
        msmeDashboardError: true,
        msmeDashboardData: null,
      };

    case MSME_ADD_CONV_LOADING:
      return {
        ...state,
        msmeAddConvLoading: true,
        msmeAddConvSuccess: false,
        msmeAddConvError: false,
      };
    case MSME_ADD_CONV_SUCCESS:
      return {
        ...state,
        msmeAddConvLoading: false,
        msmeAddConvSuccess: true,
        msmeAddConvError: false,
      };
    case MSME_ADD_CONV_ERROR:
      return {
        ...state,
        msmeAddConvLoading: false,
        msmeAddConvSuccess: false,
        msmeAddConvError: true,
      };

    case MSME_GET_CONV_LOADING:
      return {
        ...state,
        msmeGetConvLoading: true,
        msmeGetConvSuccess: false,
        msmeGetConvError: false,
        msmeConversations: [],
      };
    case MSME_GET_CONV_SUCCESS:
      return {
        ...state,
        msmeGetConvLoading: false,
        msmeGetConvSuccess: true,
        msmeGetConvError: false,
        msmeConversations: action.payload,
      };
    case MSME_GET_CONV_ERROR:
      return {
        ...state,
        msmeGetConvLoading: false,
        msmeGetConvSuccess: false,
        msmeGetConvError: true,
        msmeConversations: [],
      };

    case MANUFACTURING_DATA_LOADING:
      return {
        ...state,
        manufacturingDashboardLoading: true,
        manufacturingDashboardSuccess: false,
        manufacturingDashboardError: false,
        manufacturingDashboardData: null,
      };
    case MANUFACTURING_DATA_SUCCESS:
      return {
        ...state,
        manufacturingDashboardLoading: false,
        manufacturingDashboardSuccess: true,
        manufacturingDashboardError: false,
        manufacturingDashboardData: action.payload,
      };
    case MANUFACTURING_DATA_ERROR:
      return {
        ...state,
        manufacturingDashboardLoading: false,
        manufacturingDashboardSuccess: false,
        manufacturingDashboardError: true,
        manufacturingDashboardData: null,
      };
    case DELETE_GROUPS_SUCCESS:
      return {
        ...state,
        deleteGroupSuccess: true,
        deleteGroupError: false,
      };
    case DELETE_GROUPS_ERROR:
      return {
        ...state,
        deleteGroupSuccess: false,
        deleteGroupError: true,
      };

    case HOF_DASHBOARD_SUCCESS:
      return {
        ...state,
        hofDashboardSuccess: true,
        hofDashboardError: false,
        hofDashboardData: action.payload,
      };
    case HOF_DASHBOARD_ERROR:
      return {
        ...state,
        hofDashboardSuccess: false,
        hofDashboardError: true,
        hofDashboardData: null,
      };

    case MARUTI_DASHBOARD_LOADING:
      return {
        ...state,
        marutiDashboardLoading: true,
        marutiDashboardSuccess: false,
        marutiDashboardError: false,
        marutiDashboardData: null,
      };
    case MARUTI_DASHBOARD_SUCCESS:
      return {
        ...state,
        marutiDashboardLoading: false,
        marutiDashboardSuccess: true,
        marutiDashboardError: false,
        marutiDashboardData: action.payload,
      };
    case MARUTI_DASHBOARD_ERROR:
      return {
        ...state,
        marutiDashboardLoading: false,
        marutiDashboardSuccess: false,
        marutiDashboardError: true,
        marutiDashboardData: null,
      };

    case LOGOUT_SUCCESS:
      return initState;
    default:
      return state;
  }
};

export default billReducer;
